// extracted by mini-css-extract-plugin
export default {"customTabs":"tabs_customTabs__P-U90"};